import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Row, Col, Layout } from 'antd';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import UserMenu from '../../dashboard/layout/user-menu';
import AuthMenu from '../auth-menu';
import { LangMenu } from '../lang-menu';

const { Header } = Layout;

// LandingHeader component;
class LandingHeader extends Component {
  static propTypes = {
    isLoggedIn: PropTypes.bool.isRequired,
  };

  render() {
    const { isLoggedIn } = this.props;
    return (
      <Header className="landing__header">
        <div className="container">
          <Row type="flex" justify="space-between" align="middle">
            <Col span={18} sm={8} className="landing-logo">
              <Link to="/">
                <img src="/img/logo.svg" className="lading-logo--img" />
              </Link>
            </Col>
            <Col className="landing__header--menu" span={24} sm={16}>
              <Row className="landing__header--account-btns" type="flex" justify="end">
                <Col className="landing__header--lang-menu" span={5}>
                  <Link className="ant-dropdown-link" to="/contacts">
                    <FormattedMessage
                      id="landing.menu.contacts"
                      defaultMessage="Contacts"
                      description="Menu title for contacts route"
                    />
                  </Link>
                </Col>
                <Col className="landing__header--lang-menu" span={5}>
                  <LangMenu />
                </Col>
                <Col className="landing__header--login-menu">{isLoggedIn ? <UserMenu /> : <AuthMenu />}</Col>
              </Row>
            </Col>
          </Row>
        </div>
      </Header>
    );
  }
}

export default LandingHeader;



// WEBPACK FOOTER //
// ./src/components/landing/common/Header.js